module.exports = __webpack_public_path__ + "img/image2.50ef7b32.png";